import React from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import moment from 'moment/moment';
import { updateIntegrationAccessToken } from 'flow/actions/integration-access-actions';
import BaseModal from 'flow/components/ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';
import { ExtensionKey, IntegrationAccessKey } from 'flow/types/EntityKeys';
import { ISO_8601_MS_RESOLUTION } from 'flow/utils';

interface Props {
    id?: IntegrationAccessKey;
    extensionKey?: ExtensionKey;
}

const RevokeTokenDialog = ({ id, extensionKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const revokeToken = () => {
        const integrationAccessDTO = {
            key: id,
            invalidatedDate: moment().format(ISO_8601_MS_RESOLUTION),
        };

        dispatch(
            updateIntegrationAccessToken(
                extensionKey,
                id,
                integrationAccessDTO,
            ),
        );
    };

    return (
        <BaseModal
            open={true}
            header={i18next.t('settings.integrations.revoke_token')}
            onSubmit={revokeToken}
            confirmButtonText={i18next.t('revoke')}
        >
            {i18next.t('settings.integrations.revoke_token_question') +
                ' ' +
                i18next.t('settings.integrations.cant_undo')}
        </BaseModal>
    );
};

export default RevokeTokenDialog;
